import React from "react";
import {
  MDBDatatable,
  MDBCol,
  MDBDatepicker,
  MDBRow
} from "mdb-react-ui-kit";
import FilterInput from "../CommonViewComponents/FilterInput";
import SelectField from "../../../Components/SelectField";
import Button from "../../../Components/Button";
import CommonViewLayout from "./CommonViewLayout";

const Application = () => {
  return (
    <CommonViewLayout headerTitle="Applications" filters={<Filters />} iconName="chart-area">
      <MDBDatatable striped data={getDummyData()} />
    </CommonViewLayout>
  );
};

const Filters = () => (
  <MDBRow>
    <FilterInput label="Applicant Name" />
    <FilterInput label="Applicant Version" />
    <PropertySelect />
    <DateSelect />
    <FilterButton />
  </MDBRow>
);

const PropertySelect = () => (
  <MDBCol md="2" className="mb-4 mb-md-0">
    <SelectField
      label="Property Name"
      data={[
        { text: "Magnolia Place", value: 1, selected: true },
        { text: "111 Own at", value: 2 },
      ]}
      search={false}
    />
  </MDBCol>
);

const DateSelect = () => (
  <MDBCol md="2" className="mb-4 mb-md-0">
    <MDBDatepicker label='Submitted Date' inline />
  </MDBCol>
);

const FilterButton = () => (
  <div className="col-md-4">
    <Button type="submit" className="mb-3">
      Filter Result
    </Button>
  </div>
);

const getDummyData = () => ({
  columns: ["Applicant Name", "Applicant Version", "Property Name", "Submitted Date"],
  rows: [
    ["Crocker Betty", "GAPP-MPIH5", "Miramar", "6/20/2023"],
    ["Crocker Betty", "GAPP-MPIH5", "Miramar", "6/20/2023"],
    ["Crocker Betty", "GAPP-MPIH5", "Miramar", "6/20/2023"],
  ],
});

export default Application;
